// extracted by mini-css-extract-plugin
export default {"customScroll":"createShipmentModal_customScroll__0Z9Bv"};